import Guarantee from './components/Guarantee';

export const guarantee = {
  firstLevel: Guarantee,
};